<template>
  <form ref="form" class="needs-validation" @submit.prevent="save">
    <div class="row">
      <div v-if="title" class="col-sm-12 my-3">
        <h3>{{ title }}</h3>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label"> Artículo </label>

          <el-select
            v-model="formData.article"
            v-validate="modelValidations.article"
            autocomplete="off"
            filterable
            name="article"
            placeholder="Artículo"
          >
            <el-option v-for="option in articlesOptions" :key="option.value" :label="option.label" :value="option">
            </el-option>
          </el-select>

          <small v-show="article.invalid" class="text-danger">
            {{ getError('article') }}
          </small>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label"> Cantidad </label>

          <el-input
            v-model="formData.quantity"
            v-validate="modelValidations.quantity"
            name="quantity"
            pattern="[0-9]+"
            placeholder="Cantidad"
            suffix-icon="fas fa-boxes"
            type="number"
          >
          </el-input>

          <small v-show="quantity.invalid" class="text-danger">
            {{ getError('quantity') }}
          </small>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label"> Precio Unitario (USD) </label>

          <el-input
            v-model="formData.price"
            v-validate="modelValidations.price"
            name="price"
            pattern="[0-9]+([\.,][0-9]+)?"
            placeholder="Precio Unitario"
            step="0.01"
            suffix-icon="fas fa-dollar-sign"
            type="number"
          >
          </el-input>

          <small v-show="price.invalid" class="text-danger">
            {{ getError('price') }}
          </small>
        </div>
      </div>

      <div class="col-sm-2 pt-4">
        <base-button class="rounded-pill mt-2" native-type="submit" size="sm" type="success">
          <i class="fas fa-plus-circle mr-1"></i><span>Agregar</span>
        </base-button>
      </div>
    </div>
    <div v-if="!hasArticles" class="row">
      <div class="col">
        <p class="font-italic text-danger">Asegúrese de tener artículos cargados para la variedad asociada</p>
      </div>
    </div>
  </form>
</template>

<script>
import { Select, Option } from 'element-ui';
import { mapFields } from 'vee-validate';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    title: {
      type: String,
      default: 'Agregar Artículos',
    },

    quotation: {
      type: Number,
      required: true,
    },

    campaign: {
      type: Object,
      required: true,
    },

    projection: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      validated: false,
      formData: {
        article: null,
        quantity: null,
        price: null,
      },

      modelValidations: {
        article: {
          required: true,
        },

        quantity: {
          required: true,
          numeric: true,
        },

        price: {
          required: true,
          decimal: 2,
        },
      },

      articles: [],
    };
  },

  computed: {
    ...mapFields(['article', 'quantity', 'price']),
    articlesOptions() {
      return this.$selectOptions(this.articles, { sort: true, label: 'description' });
    },

    hasArticles() {
      return this.articles.length > 0;
    },
  },

  mounted() {
    this.fetchArticles();
    this.formData.quantity = this.projection !== null ? this.projection.quantity : null;
  },

  methods: {
    fetchArticles() {
      this.$services
        .resource('articles')
        .get(this.getParams())
        .then((res) => res.data.data)
        .then((data) => (this.articles = data.articles));
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((valid) => {
        if (valid) {
          let newItem = {
            article: this.articles.find((a) => this.formData.article.value === a.id),
            quantity: +this.formData.quantity,
            price: +this.formData.price,
          };
          this.$services
            .resource('quotation_items')
            .setQuotation(this.quotation)
            .create(newItem)
            .then((res) => {
              newItem = res.data.data;
              this.$emit('addItem', newItem);
            });
        }
      });
    },

    clean() {
      this.formData.article = null;
      this.formData.quantity = null;
      this.formData.price = null;
      this.validated = false;
      this.errors.clear();
      this.$validator.reset();
    },

    reset() {
      this.$refs.form.reset();
      this.clean();
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },

    getParams() {
      let params = {
        'filter[campaign]': this.campaign.id,
        'filter[articles_for_sale]': true,
      };
      return params;
    },
  },
};
</script>
